import { render, staticRenderFns } from "./ElementCard.vue?vue&type=template&id=32b0ccae&scoped=true"
import script from "./ElementCard.vue?vue&type=script&lang=js"
export * from "./ElementCard.vue?vue&type=script&lang=js"
import style0 from "./ElementCard.vue?vue&type=style&index=0&id=32b0ccae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b0ccae",
  null
  
)

export default component.exports